import { computed } from 'vue';
import { type RouteRecordRaw } from 'vue-router';

import { useGlobalI18n } from '@abaninja/util-i18n';

const { global: { t } } = useGlobalI18n();

export const routes: RouteRecordRaw[] = [
  {
    path: 'digital-coach',
    children: [
      {
        name: 'digital-coach-profile',
        path: 'profile',
        component: () => import('../DigitalCoachProfileIndex.vue'),
        meta: {
          isUserRoleOr: ['DC'],
          title: computed(() => t('messages.digitalCoachSettings', 2)),
        },
      },
    ],
  },
];
